import { secondsInMinute } from 'date-fns'

export const secondsToMinAndSec = (totalSeconds: number): [number, number] => {
  const min = Math.floor(totalSeconds / secondsInMinute)
  const sec = totalSeconds % secondsInMinute

  return [min, sec]
}
